<template>
  <div>
    <div class="modal fade" id="addDelegacjaModal" ref="modalEle" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Kwoty pobrane</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="mb-0">Lista pobranych kwot</h6>
              <button v-if="!readonly" class="btn btn-sm btn-success" @click="addKwota"><i class="bi bi-plus-lg me-1"></i> Dodaj
                kwotę</button>
            </div>
            <div class="custom-table">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Kwota</th>
                    <th>Waluta</th>
                    <th>Data</th>
                    <th>Akcje</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(kwota, index) in kwoty" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <input v-if="editingId === kwota.id" v-model="kwota.kwota" type="number" step="0.01" class="form-control"/>
                      <span v-else>{{ kwota.kwota }}</span>
                    </td>
                    <td>
						<select v-if="editingId === kwota.id" v-model="kwota.waluta" class="form-select" style="max-width:100px;">
												<option v-for="c in currencys" :key="c.id" :value="c.name">{{ c.name }}
												</option>
											</select> 
					<span v-else>{{ kwota.waluta }}</span>
                    </td>
                    <td>
					  <input v-if="editingId === kwota.id" type="date" v-model="kwota.data" class="form-control">
                      <span v-else>{{ kwota.data }}</span>
                    </td> 
                    <td>
                      <button v-if="!readonly && editingId === kwota.id" @click="updateKwota(kwota)" class="btn btn-sm btn-success me-2">
                        Zapisz
                      </button>
                      <button v-else-if="!readonly" @click="editKwota(kwota.id)" class="btn btn-sm btn-outline-info me-2"><i
                          class="bi bi-pencil me-2"></i>Edytuj
                      </button>
                      <button v-if="!readonly" @click="deleteKwota(kwota.id)" class="btn btn-sm btn-danger">
                        <i class="bi bi-trash me-2"></i>Usuń
                      </button>
                    </td>
                  </tr>
                  <tr v-if="addingNew">
                    <td>#</td>
                    <td><input v-model="newKwota.kwota" type="number" step="0.01" class="form-control" placeholder="0.00"/></td>
					<td>
											<select v-model="newKwota.waluta" class="form-select" style="max-width:100px;">
												<option v-for="c in currencys" :key="c.id" :value="c.name">{{ c.name }}
												</option>
											</select>
					</td>

					<td>
					<input type="date" v-model="newKwota.data" class="form-control">
					</td>
                    <td>
                      <button v-if="!readonly" @click="saveNewKwota" class="btn btn-sm btn-success me-1"><i
                          class="bi bi-save me-2"></i>Zapisz
                      </button>
                      <button @click="cancelNewKwota" class="btn btn-sm btn-danger"><i
                          class="bi bi-x-circle me-2"></i>Anuluj
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>


          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Zamknij</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { Modal } from 'bootstrap';
import { ComboBoxComponent } from "@syncfusion/ej2-vue-dropdowns";

export default {
	props:{
		currencys: { type: Array, default: () => [] },
		delegacja:{
			type:Object,
			default:null
		},
		readonly: {
		type: Boolean,
		default: false
		}		
	},
	components: {
		'ejs-combobox': ComboBoxComponent
	},
  data() {
    return {
      modalObj: null,
      editingId: null,
      addingNew: false,
      newKwota: this.getEmptyForm()
    };
  },
computed:{
    kwoty(){
        return this.delegacja?.kwoty_pobrane ?? [];
    }
},
  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
  },

  methods: {
    resetForm() {
      this.editingId = null;
      this.addingNew = false;
      this.newKwota = this.getEmptyForm();
    },
getEmptyForm() {
    return {
        id:null,
        delegacja_id:this.delegacja?.id,
        kwota:'',
        waluta:'PLN',
        data:new Date().toISOString().slice(0,10)
    };
},

    addKwota() {
      this.addingNew = true;
      this.newKwota = this.getEmptyForm();
    },

    cancelNewKwota() {
      this.addingNew = false;
      this.newKwota = this.getEmptyForm();
    },

    editKwota(id) {
      this.editingId = id;
    },

    updateKwota(kwota) {
      this.$emit("update-kwota", { ...kwota });
      this.resetForm();
      this.hide();
    },

    saveNewKwota() {
      if (!this.newKwota) {
        this.errorMsg("Podaj kwotę.");
        return;
      }
      this.$emit("save-kwota", this.newKwota);
      this.resetForm();
      this.hide();
    },

    deleteKwota(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie celu delegacji',
        html: 'Czy na pewno chcesz usunąć pobraną kwotę?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {

          this.$emit("delete-kwota", id);
          this.resetForm();
          this.hide();

        }

      });
    },

    show() {
      this.modalObj.show();
    },
    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },


    hide() {
      this.resetForm();

      if (this.modalObj) {
        this.modalObj.hide();
      }
    }
  }
};
</script>

<style>
.position-absolute {
  background: white;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
}
</style>